import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { appVariables } from '../../app.constants';

@Component({
  selector: 'app-title',
  templateUrl: `./unauthorized.component.html`,
  styleUrls: ['./unauthorized.component.scss']
})
export class unauthorizedComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit(): void { }

 navigateToservicenow() {
  window.open(appVariables.servicenowUrl);
}
 navigateToAthenaMobileApp(){
  window.open(appVariables.athenaMobileApp);
}
}
